import { vModelCheckbox as _vModelCheckbox, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "default-checker default-checker--filter" }
const _hoisted_2 = { class: "default-checker__checkbox default-checker__checkbox--ma_none" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "default-checker__description" }
const _hoisted_5 = { class: "ds-caption ds-caption--color_grey ds-caption--size_sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["wg-checkbox-main", $setup.val ? 'wg-checkbox-main--active' : 'wg-checkbox-main'])
      }, [
        _createElementVNode("label", null, [
          _withDirectives(_createElementVNode("input", _mergeProps({ class: "checker" }, _ctx.$attrs, {
            type: "checkbox",
            value: $setup.val,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.val) = $event)),
            onChange: _cache[1] || (_cache[1] = ($event: any) => ($setup.setValue($setup.val)))
          }), null, 16, _hoisted_3), [
            [_vModelCheckbox, $setup.val]
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "wg-checkbox-main__label" }, [
            _createElementVNode("img", { src: "/static/img/check-icon.svg" })
          ], -1))
        ])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", _hoisted_5, _toDisplayString($props.label), 1)
    ])
  ]))
}